/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CustomizeBaseProductProductForRestaurantQueryVariables = Types.Exact<{
  baseProductSlug: Types.Scalars['String']['input'];
  restaurantId: Types.Scalars['String']['input'];
}>;

export type CustomizeBaseProductProductForRestaurantQuery = {
  readonly __typename?: 'Query';
  readonly productForRestaurant: {
    readonly __typename: 'Product';
    readonly id: string;
    readonly slug: string;
    readonly isModifiable: boolean;
    readonly outOfStock: boolean;
    readonly restaurant: {
      readonly __typename: 'Restaurant';
      readonly id: string;
      readonly slug: string;
    };
  } | null;
};

export const CustomizeBaseProductProductForRestaurantDocument = gql`
  query CustomizeBaseProductProductForRestaurant(
    $baseProductSlug: String!
    $restaurantId: String!
  ) {
    productForRestaurant(baseProductSlug: $baseProductSlug, restaurantId: $restaurantId) {
      __typename
      id
      slug
      isModifiable
      outOfStock
      restaurant {
        __typename
        id
        slug
      }
    }
  }
`;

export function useCustomizeBaseProductProductForRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<CustomizeBaseProductProductForRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    CustomizeBaseProductProductForRestaurantQuery,
    CustomizeBaseProductProductForRestaurantQueryVariables
  >({ query: CustomizeBaseProductProductForRestaurantDocument, ...options });
}
